<template>
  <div class="home">
    <top :p="0"></top>
    
    <lbt></lbt>
    <right></right>
    
    <bar></bar>
  </div>
</template>

<script>
import top from "../components/top.vue"
import bar from "../components/bar.vue"
import lbt from "../components/lbt.vue"
import right from "../components/right.vue"
	
export default {
	  name: 'HomeView',
	  components: {
		top,
		bar,
		lbt,
		right,
	  },
	  data() {
		return {
			
		}
	  },
	  created() {
			
			
	  },
	  methods:{
		 
		  
		  
	  },
	  
	  beforeDestroy(){	//退出页面时间
			
	  }
  
}
</script>
<style scoped lang="less">
	.home{
		width: 1920px;
		height: 100vh;
		position: relative;
		overflow: hidden;
		background-color: #fff;
	}
	
	
</style>
